import React, { Component } from 'react';
import FJLocalStore from '../../../store/FJLocalStore';
import classNames from 'classnames';
import FJDropDown from '../FJDropDown/FJDropDown';
import FJArrowUpDownIcon from '../../../assets/svg/search/arrow-bottom.svg?react';
import FJCheckIcon from '../../../assets/svg/search/check.svg?react';

import Style from './FJSearchTypeDropdown.module.less';

const List = ({ list, curIndex, dataChange }) => {
    return list.map((item, index) => {
        let className = classNames(Style.item, curIndex === index ? Style.active : null);
        return (
            <div className={className} key={index} onClick={() => dataChange(index)}>
                <FJCheckIcon />
                {FJLocalStore._(item.value)}
            </div>
        );
    });
};

class FJSearchTypeDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0,
        };
    }
    render() {
        let { list } = this.props;
        let currentValue = FJLocalStore._(list[this.state.activeIndex].value);
        let triggerCN = classNames(Style.trigger);

        return (
            <FJDropDown
                overlay={
                    <div className={Style.panel}>
                        <List list={list} curIndex={this.state.activeIndex} dataChange={this._dataChange} />
                    </div>
                }
                placement='bottomLeft'
                overlayClassName={Style.box}
                isTopLayer
                triggerDisplay='flex'
                ref={ele => (this.dropDown = ele)}
                hasArrow={false}
            >
                <div className={triggerCN}>
                    <div className={Style.currentValue}>{currentValue}</div>
                    <div className={Style.icon}>
                        <FJArrowUpDownIcon />
                    </div>
                </div>
            </FJDropDown>
        );
    }

    _dataChange = index => {
        this.setState({
            activeIndex: index,
        });
        if (this.props.dataChange) {
            this.props.dataChange(index);
        }
        this.hideDropdown();
    };

    hideDropdown = () => {
        this.dropDown.hide();
    };
}

export default FJSearchTypeDropdown;
